import { OrderStatus } from '../../../../../../graphql/order/models';

export const getStatusDate = (
  orderStatus: OrderStatus,
  {
    deliveryDate,
    purchaseDate,
    lastModifiedDateTime,
  }: {
    deliveryDate?: string | null;
    purchaseDate?: string | null;
    lastModifiedDateTime?: string;
  },
): Date | null => {
  if (orderStatus === OrderStatus.confirmed && deliveryDate) {
    const date = new Date(deliveryDate);
    date.setDate(date.getDate() + 7);
    return date;
  }

  if (
    (orderStatus === OrderStatus.processing
      || orderStatus === OrderStatus.externalOrderCreated
      || orderStatus === OrderStatus.new)
    && deliveryDate
  ) {
    return new Date(deliveryDate);
  }

  if (orderStatus === OrderStatus.fulfilled && purchaseDate) {
    return new Date(purchaseDate);
  }

  if (
    orderStatus === OrderStatus.canceled
    || orderStatus === OrderStatus.canceledAutomatically
    || orderStatus === OrderStatus.canceledByPatient
  ) {
    return lastModifiedDateTime
      ? new Date(lastModifiedDateTime)
      : null;
  }

  return null;
};

